module.exports = __webpack_public_path__ + "img/eTailing Summit.deea9dc3.png";